import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.oms')
  .factory('OmsOrdersMessagesAPI', OmsOrdersMessagesAPI);

function OmsOrdersMessagesAPI(): BringozApi {
  return {
    base: `/messages/order-sms`,
    infiniteScroll: {
      address: `/messages/order-sms`,
      cmd: 'GET'
    },
    actions: {
      send: {
        address: '',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}
